import {
  useMediaQuery,
  WhmDivider,
  WhmStack,
  whmTheme,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { ReactComponent as Empty } from "./Empty.svg";
import { Link } from "react-router-dom";
import { ReactComponent as RightArrow } from "@securitize/assets-sec-ui/dist/icons/svg/arrow-line-right.svg";
import { Translate } from "../../../../../Translation/Translate";
import { translationKeys } from "../../../../../../contexts/I18nContext";
import { WhmResponsiveStack } from "../../../../../shared/WhmResponsiveStack";
import useUserInfo from "../../../../../../hooks/useUserInfo";

export default function AssetsEmptyState() {
  const isMobile = useMediaQuery(whmTheme.breakpoints.down("xl"));
  const { hasBdAccess } = useUserInfo();

  // Investors without BD access can't reach Primary/Secondary Markets, so the
  // legacy CTA cards (which deep-link there) become dead ends. The gated copy
  // strips them and reduces the empty state to title + a single explanatory
  // sentence.
  if (!hasBdAccess) {
    return (
      <WhmStack alignItems="center" padding="24px" gap="16px">
        <Empty />
        <WhmStack alignItems="center" gap="8px">
          <WhmTypography variant="h4">
            <Translate
              translationKey={
                translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_TITLE
              }
            />
          </WhmTypography>
          <WhmTypography variant="body1" color="text.secondary">
            <Translate
              translationKey={
                translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_GATED_DESCRIPTION
              }
            />
          </WhmTypography>
        </WhmStack>
      </WhmStack>
    );
  }

  return (
    <WhmStack alignItems="center" padding="24px" gap="16px">
      <Empty />
      <WhmStack alignItems="center" gap="32px">
        <WhmTypography variant="h4">
          <Translate
            translationKey={
              translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_TITLE
            }
          />
        </WhmTypography>
        <WhmResponsiveStack
          gap="24px"
          divider={
            <WhmDivider
              orientation={isMobile ? "horizontal" : "vertical"}
              flexItem
            />
          }
        >
          <WhmStack flex="1" gap="16px" textAlign="center">
            <WhmTypography variant="subtitle1">
              <Translate
                translationKey={
                  translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_PRIMARY_MARKET_TITLE
                }
              />
            </WhmTypography>
            <WhmTypography variant="body1" color="text.secondary">
              <Translate
                translationKey={
                  translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_PRIMARY_MARKET_DESCRIPTION
                }
              />
            </WhmTypography>
            <WhmTypography
              sx={{
                fontWeight: 500,
                "& a": {
                  textDecoration: "none",
                  color: "primary.main",
                },
              }}
            >
              <Link to="/primary-market">
                <Translate
                  translationKey={
                    translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_PRIMARY_MARKET_CTA
                  }
                />{" "}
                <RightArrow fill="currentColor" />
              </Link>
            </WhmTypography>
          </WhmStack>
          <WhmStack flex="1" gap="16px" textAlign="center">
            <WhmTypography variant="subtitle1">
              <Translate
                translationKey={
                  translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_SECONDARY_MARKET_TITLE
                }
              />
            </WhmTypography>
            <WhmTypography variant="body1" color="text.secondary">
              <Translate
                translationKey={
                  translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_SECONDARY_MARKET_DESCRIPTION
                }
              />
            </WhmTypography>
            <WhmTypography
              sx={{
                fontWeight: 500,
                "& a": {
                  textDecoration: "none",
                  color: "primary.main",
                },
              }}
            >
              <Link to="/secondary-market">
                <Translate
                  translationKey={
                    translationKeys.PORTFOLIO_MY_ASSETS_EMPTY_STATE_SECONDARY_MARKET_CTA
                  }
                />{" "}
                <RightArrow fill="currentColor" />
              </Link>
            </WhmTypography>
          </WhmStack>
        </WhmResponsiveStack>
      </WhmStack>
    </WhmStack>
  );
}
